// src/components/AlertBanner.js
import React from 'react';
import { useRaveAlert } from '../hooks/useRaveAlert';
import './AlertBanner.css';

/**
 * Reusable Alert Banner Component
 * Automatically fetches and displays Rave alerts
 */
export function AlertBanner() {
  const { alertData, isLoading, error } = useRaveAlert();

  // Don't render anything if loading or no active alert
  if (isLoading || !alertData.isActive) {
    return null;
  }

  // Don't render if there's an error (fail silently)
  if (error) {
    console.warn('AlertBanner: Error loading alert data', error);
    return null;
  }

  return (
    <div className="alert-banner" role="alert" aria-live="polite">
      <div className="alert-banner-content">
        <div className="alert-icon">
          <img 
            src="/themes/oeduVitb/images/alerticon.png" 
            alt="Alert icon"
            className="alert-icon-image"
            onError={(e) => {
              // Hide image if it fails to load
              e.target.style.display = 'none';
            }}
          />
        </div>
        <div className="alert-text">
          <h5 className="alert-title">{alertData.title}</h5>
          <div className="alert-description">{alertData.description}</div>
        </div>
      </div>
    </div>
  );
}